import { fetchData, makeGet } from '../util';
export function getUserProfile() {
    const url = `/api/@me`;
    return fetchData(makeGet(url))
        .then((x) => x.body);
}
// TODO: Needs better parsed response
export function getUserCompliance(tenantId, userId) {
    const url = `/_/a/22/${tenantId}/1/${userId}/usr/Compliance`;
    return fetchData(makeGet(url))
        .then((x) => x.body[0]);
}
export function isUserCompliance(tenantId, userId) {
    return getUserCompliance(tenantId, userId)
        .then((x) => x.isCompliant === true);
}
//# sourceMappingURL=user.js.map